import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { PageMode } from "utils/constant";
import TableComponent from "./components/Table";
import FormComponent from "./components/Form";
import { useSelector } from "react-redux";

const RegisterMalaria1 = () => {
  const [pageMode, setPageMode] = useState(PageMode.view);
  const [pageTitle, setPageTitle] = useState("");

  const { currentUser } = useSelector((state) => state.authReducer);

  const isBKKUser =
    currentUser.level === "BKKWilker" || currentUser.level === "BKKInduk";

  const isNotifikasiBKK = window.location.pathname
    .toLowerCase()
    .includes("/notifikasi-kasus-bkk");

  useEffect(() => {
    let title = "";
    if (isNotifikasiBKK) {
      title = "Notifikasi Kasus BKK";
    } else if (isBKKUser) {
      title = "Register Malaria 1 BKK";
    } else {
      title = "Register Malaria 1";
    }
    document.title = "SISMAL | " + title;
    setPageTitle(title);
    window.scrollTo(0, 0);
  }, []);

  const changePageMode = (mode) => {
    setPageMode(mode);
  };

  return (
    <div className="dashboard-wrapper">
      {pageMode === PageMode.view && (
        <TableComponent
          changeMode={changePageMode}
          pageMode={pageMode}
          pageTitle={pageTitle}
          isNotifikasiBKK={isNotifikasiBKK}
        />
      )}
      {(pageMode === PageMode.add || pageMode === PageMode.edit) && (
        <FormComponent
          changeMode={changePageMode}
          pageMode={pageMode}
          isNotifikasiBKK={isNotifikasiBKK}
        />
      )}
    </div>
  );
};

export default RegisterMalaria1;
